import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Text, Flex, xcss } from '@atlaskit/primitives';

const optionStyles = xcss({
	paddingTop: 'space.050',
	paddingBottom: 'space.050',
	flexDirection: 'column',
});

type OptionWithWithDescriptionProps = {
	label: string;
	description: string;
	isSelected: boolean;
	isMenu: boolean;
	isRbacEnabled: boolean;
};

export const OptionWithDescription = ({
	label,
	description,
	isSelected,
	isMenu,
	isRbacEnabled,
}: OptionWithWithDescriptionProps): JSX.Element => (
	<Flex xcss={optionStyles}>
		<Text weight={!isMenu && isRbacEnabled ? 'bold' : 'regular'}>{label}</Text>
		<Text color={isSelected ? 'color.text.subtle' : 'color.text.subtlest'} size="small">
			{description}
		</Text>
	</Flex>
);
